// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip_tooltip__ycbtL","arrow":"tooltip_arrow__zREmX"};